import React from 'react'

import ClockInUser from '../containers/clock-in/user-button'
import Shop from '../containers/shop'
import ShopInventory from '../containers/shop/inventory'
import ShopProductFilter from '../containers/shop/product-filter'
import SlidingPanels from '../components/sliding-panels'
import TransactionsHistory from '../containers/history/transactions'
import Reconciliations from '../containers/reconciliations'
import OpenGames from '../containers/open-games'
import Calendar from '../containers/calendar'
import Activities from '../containers/activities'
import AdminsTab from '../containers/admins-tab'
import Clients from '../containers/clients'
import Regions from '../containers/regions'
import Notifications from '../containers/notifications'
import RegionsFilter from '../containers/regions-filter'
import Players from '../containers/players'
import DirectMessages from '../containers/direct-messages'
import StripePluginModal from '../containers/stripe-plugin-modal'
import SideBar from '../containers/side-bar'
import PushNotifications from '../containers/push-notifications'
import AutoMessages from '../containers/auto-messages'
import MessageTemplates from '../containers/message-templates'
import Leagues from '../containers/leagues'
import League from '../containers/league'
import GameAutoMessages from '../containers/game-auto-messages'
import ClientPortal from '../containers/client-portal'
import LandingPage from '../containers/landing-page'
import ResetPasswordForm from '../containers/reset-password-form'
import Banners from '../containers/banners'
import Partners from '../containers/partners'
import Partner from '../containers/partner'

const getRootComponent = type => {
  switch (type) {
    case 'CLOCK_IN_USER_BUTTON': return <ClockInUser />
    case 'SHOP':                 return <Shop />
    case 'SHOP_INVENTORY':       return <ShopInventory />
    case 'SHOP_PRODUCT_FILTER':  return <ShopProductFilter />
    case 'SLIDING_PANELS':       return <SlidingPanels />
    case 'TRANSACTIONS_HISTORY': return <TransactionsHistory />
    case 'RECONCILIATIONS':      return <Reconciliations />
    case 'OPEN_GAMES':           return <OpenGames />
    case 'CALENDAR':             return <Calendar />
    case 'ADMINS_TAB':           return <AdminsTab />
    case 'ACTIVITIES':           return <Activities />
    case 'CLIENTS':              return <Clients />
    case 'REGIONS':              return <Regions />
    case 'NOTIFICATIONS':        return <Notifications />
    case 'PLAYERS':              return <Players />
    case 'DIRECT_MESSAGES':      return <DirectMessages />
    case 'STRIPE_PLUGIN_MODAL':  return <StripePluginModal />
    case 'SIDE_BAR':             return <SideBar />
    case 'PUSH_NOTIFICATIONS':   return <PushNotifications />
    case 'AUTO_MESSAGES':        return <AutoMessages />
    case 'GAME_AUTO_MESSAGES':   return <GameAutoMessages />
    case 'CLIENT_PORTAL':        return <ClientPortal />
    case 'MESSAGE_TEMPLATES':    return <MessageTemplates />
    case 'LEAGUES':              return <Leagues />
    case 'LEAGUE':               return <League />
    case 'REGIONS_FILTER':       return <RegionsFilter />
    case 'LANDING_PAGE':         return <LandingPage />
    case 'RESET_PASSWORD_FORM':  return <ResetPasswordForm />
    case 'BANNERS':              return <Banners />
    case 'PARTNERS':             return <Partners />
    case 'PARTNER':              return <Partner />
  }
}

export default getRootComponent
